/* 🎨 STYLES */
import { Container, TextLabel, Icon } from "./styles";

const Label = (props) => {

    return(
        <Container $aling={props.aling}>
            {props.icon && <Icon src={props.icon} />}
            <TextLabel>{props.text}</TextLabel>
        </Container>
    )
}

export default Label;